import React from "react";
import styled from "styled-components";

// Styled-components for Title and Summary
const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding-top: 2rem;
`;

const TitleText = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 0.5rem;
`;

const SummaryText = styled.p`
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  font-style: italic;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
`;

// Title component with props for title and summary
const Title = ({ title, summary }) => {
  return (
    <TitleWrapper>
      <TitleText>{title}</TitleText>
      <SummaryText>{summary}</SummaryText>
    </TitleWrapper>
  );
};

export default Title;
